import { useUser } from "@/client/services/user";
import { useMyWithdrawals } from "@/client/services/withdrawals/my-withdrawals";
import { useDialog } from "@/client/stores/dialog";
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  ScrollArea,
} from "@reactive-resume/ui";
import { WithdrawalWithUser } from "libs/dto/src/withdrawal";
import { useState } from "react";
import { WithdrawalTable } from "../overview/section/withdrawal-table";
import { CaretCircleLeftIcon, CaretCircleRightIcon } from "@phosphor-icons/react";
import { Navigate } from "react-router";

export const MyWithdrawalDialog = () => {
  const { isOpen, mode, payload, close } = useDialog<WithdrawalWithUser>("my-withdrawals");
  const isReaded = mode === "read";
  const { user } = useUser();
  const [pageWithdrawal, setPageWithdrawal] = useState(1);

  if (user) {
    const { withdrawal } = useMyWithdrawals(user.id, pageWithdrawal);
    const handleBackpageWithdrawal = () => setPageWithdrawal(pageWithdrawal - 1);
    const handleForwardpageWithdrawal = () => setPageWithdrawal(pageWithdrawal + 1);
    const handleSpecficpageWithdrawal = (newpage: number) => setPageWithdrawal(newpage);

    return (
      <Dialog open={isOpen} onOpenChange={close}>
        <DialogContent className="lg:max-w-[820px]">
          <DialogHeader>
            <DialogTitle>My withdrawals</DialogTitle>
          </DialogHeader>
          <ScrollArea allowOverflow className="overflow-auto object-center lg:w-full">
            <WithdrawalTable data={withdrawal?.data} />
          </ScrollArea>
          <div className="my-3 flex flex-row space-x-3">
            <div className="flex-1"></div>
            {pageWithdrawal > 1 && (
              <Button onClick={handleBackpageWithdrawal}>
                <CaretCircleLeftIcon size={32} color="#fcfcfc" weight="regular" />
              </Button>
            )}

            {pageWithdrawal - 2 > 0 && (
              <Button onClick={() => handleSpecficpageWithdrawal(pageWithdrawal - 2)}>
                {pageWithdrawal - 2}
              </Button>
            )}
            {pageWithdrawal - 1 > 0 && (
              <Button onClick={() => handleSpecficpageWithdrawal(pageWithdrawal - 1)}>
                {pageWithdrawal - 1}
              </Button>
            )}

            <Button>{pageWithdrawal}</Button>
            {withdrawal && pageWithdrawal + 1 <= withdrawal.page && (
              <Button onClick={() => handleSpecficpageWithdrawal(pageWithdrawal + 1)}>
                {pageWithdrawal + 1}
              </Button>
            )}
            {withdrawal && pageWithdrawal + 2 <= withdrawal.page && (
              <Button onClick={() => handleSpecficpageWithdrawal(pageWithdrawal + 2)}>
                {pageWithdrawal + 2}
              </Button>
            )}
            {withdrawal && pageWithdrawal < withdrawal.page && (
              <Button onClick={handleForwardpageWithdrawal}>
                <CaretCircleRightIcon size={32} color="#fcfcfc" weight="regular" />
              </Button>
            )}
            <div className="flex-1"></div>
          </div>
        </DialogContent>
        <DialogFooter></DialogFooter>
      </Dialog>
    );
  }
};
